import React from "react";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";

import styles from "./styles.scss";

export default class extends React.Component {
  handleChange = (context) => {
    this.props.onChange({ ...this.props.item, context: context.value });
  };

  handleDateChange = (date) => {
    this.props.onChange({ ...this.props.item, date });
  };

  handleDateToChange = (dateTo) => {
    this.props.onChange({ ...this.props.item, dateTo });
  };

  handleCustomChange = (e) => {
    this.props.onChange({
      ...this.props.item,
      custom: e.target.value,
    });
  };

  handleRemove = () => {
    this.props.onChange({ uuid: this.props.item.uuid });
  };

  render() {
    const { item, options } = this.props;
    const date = item.date ? new Date(item.date) : null;
    const dateTo = item.dateTo ? new Date(item.dateTo) : null;

    const option = options.filter((x) => x.value === item.context)[0];
    const allowsDateTo = option ? option.to : null;

    return (
      <div className={styles.wrap}>
        <div style={{ flexGrow: "1", marginRight: "1em" }}>
          <Select
            value={{ value: item.context, label: item.context }}
            onChange={this.handleChange}
            options={options}
          />
        </div>

        <div>
          <DateTimePicker
            value={date}
            onChange={this.handleDateChange}
            disableClock={true}
            disableCalendar={true}
            showLeadingZeros={true}
            minDate={new Date("1900")}
            maxDate={new Date("2100")}
          />
          {!!allowsDateTo && (
            <div style={{ marginTop: "6px" }}>
              <DateTimePicker
                value={dateTo}
                onChange={this.handleDateToChange}
                disableClock={true}
                disableCalendar={true}
                showLeadingZeros={true}
                minDate={new Date("1900")}
                maxDate={new Date("2100")}
              />
            </div>
          )}

          {!!option && option.custom && (
            <div>
              <input
                className={styles.custom}
                type="text"
                value={item.custom || ""}
                placeholder={option.custom}
                onChange={this.handleCustomChange}
              />
            </div>
          )}
        </div>

        <div className={styles.x} onClick={this.handleRemove}>
          ×
        </div>
      </div>
    );
  }
}
